import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "input"]
  static values = {
    url: String,
    field: String,
    model: { type: String, default: "task" },
    multiline: { type: Boolean, default: false }
  }

  connect() {
    this.editing = false
    this.saving = false
    if (this.multilineValue && this.hasInputTarget) {
      this.autoGrow()
    }
  }

  // Lien cliquable dans un champ URL : ouvrir le lien sans passer en édition.
  stop(event) {
    event.stopPropagation()
  }

  edit(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.editing) return

    this.editing = true
    this.displayTarget.classList.add("hidden")
    this.inputTarget.classList.remove("hidden")

    if (this.multilineValue) this.autoGrow()

    this.inputTarget.focus()
    if (this.inputTarget.type !== "date" && this.inputTarget.tagName !== "TEXTAREA") {
      this.inputTarget.select()
    } else if (this.inputTarget.tagName === "TEXTAREA") {
      const len = this.inputTarget.value.length
      this.inputTarget.setSelectionRange(len, len)
    }
  }

  save() {
    if (this.saving || !this.editing) return

    const value = this.inputTarget.value
    const originalValue = (this.displayTarget.querySelector(".rw-inline-display-text") || this.displayTarget).textContent.trim()
    const placeholderSignatures = ["—", "— Ajouter"]
    const originalNormalized = placeholderSignatures.includes(originalValue) ? "" : originalValue

    if (value === originalNormalized) {
      this.cancel()
      return
    }

    this.saving = true
    this.inputTarget.classList.remove("rw-inline-input--error")

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const body = { [this.modelValue]: {} }
    body[this.modelValue][this.fieldValue] = value

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: JSON.stringify(body)
    }).then(response => {
      this.saving = false
      if (response.ok) {
        this.applyDisplayValue(value)
        this.cancel()
        this.flashSuccess()
      } else {
        this.inputTarget.classList.add("rw-inline-input--error")
      }
    }).catch(() => {
      this.saving = false
      this.inputTarget.classList.add("rw-inline-input--error")
    })
  }

  applyDisplayValue(value) {
    const textNode = this.displayTarget.querySelector(".rw-inline-display-text") || this.displayTarget
    const emptyLabel = "— Ajouter"

    if (!value || value.length === 0) {
      textNode.textContent = emptyLabel
      this.element.closest(".rw-inline-field")?.querySelector(".rw-inline-field-value")?.classList.add("is-empty")
      return
    }

    this.element.closest(".rw-inline-field")?.querySelector(".rw-inline-field-value")?.classList.remove("is-empty")

    if (this.inputTarget.type === "date") {
      const date = new Date(value + "T00:00:00")
      textNode.textContent = date.toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" })
    } else {
      textNode.textContent = value
    }
  }

  cancel() {
    this.editing = false
    this.displayTarget.classList.remove("hidden")
    this.inputTarget.classList.add("hidden")
  }

  handleKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey && !this.multilineValue) {
      event.preventDefault()
      this.save()
    } else if (event.key === "Enter" && event.metaKey && this.multilineValue) {
      event.preventDefault()
      this.save()
    } else if (event.key === "Escape") {
      this.cancel()
    }
  }

  handleBlur() {
    if (this.saving) return
    setTimeout(() => this.save(), 100)
  }

  autoGrow() {
    if (!this.hasInputTarget || this.inputTarget.tagName !== "TEXTAREA") return
    this.inputTarget.style.height = "auto"
    this.inputTarget.style.height = `${this.inputTarget.scrollHeight}px`
  }

  flashSuccess() {
    const field = this.element.closest(".rw-inline-field")
    if (!field) return
    field.classList.remove("is-just-saved")
    void field.offsetWidth
    field.classList.add("is-just-saved")
    setTimeout(() => field.classList.remove("is-just-saved"), 1200)
  }
}
